import React from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import { BsGithub } from "react-icons/bs";
import { Link } from "react-router-dom";

import Technologies from "../../components/portfolio/Technologies";
import FullCarousel from "../../components/portfolio/FullCarousel";
import Demo from "../../components/portfolio/Demo";

import img1 from "../../assets/images/portfolio/strath-booking/login.png";
import img2 from "../../assets/images/portfolio/strath-booking/admin-student.png";
import img3 from "../../assets/images/portfolio/strath-booking/booking.png";
import img4 from "../../assets/images/portfolio/strath-booking/homework.png";
import img5 from "../../assets/images/portfolio/strath-booking/booking history.png";
import img6 from "../../assets/images/portfolio/strath-booking/detention.png";
import img7 from "../../assets/images/portfolio/strath-booking/dt-list.png";
import img8 from "../../assets/images/portfolio/strath-booking/updates.png";
import img9 from "../../assets/images/portfolio/strath-booking/parents.png";

import demo1 from "../../assets/images/portfolio/strath-booking/demo1.m4v";
import demo2 from "../../assets/images/portfolio/strath-booking/demo2.m4v";
import demo3 from "../../assets/images/portfolio/strath-booking/demo3.m4v";
import demo4 from "../../assets/images/portfolio/strath-booking/demo4.m4v";

function Strathmore() {
  const technologies = ["Laravel", "Tailwind CSS", "JQuery", "MySQL", "DOMPdf"];

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img8, img9];

  const demos = [demo1, demo2, demo3, demo4];
  return (
    <div className="bg-slate-50 min-h-screen relative flex flex-col items-center">
      <div className="h-20 bg-cool-300 absolute top-0 w-full"></div>

      <div className="relative w-[90%] bg-white z-50 py-40 md:px-10 px-5 drop-shadow-md flex flex-col items-center mt-10 overflow-y-scroll h-[calc(100vh-4rem)]">
        <Link
          to="/portfolio"
          className="bg-cool-300 absolute top-10 left-10 text-white rounded-full w-20 h-20 flex items-center justify-center drop-shadow-md"
        >
          <IoArrowBackOutline size={50} />
        </Link>

        <div className="">
          <h1 className="text-cool-400 font-semibold text-4xl">
            Strathmore School Disciplinary System
          </h1>
        </div>

        <div className="w-[80%] mt-10 drop-shadow-md">
          <h2 className="py-5  text-xl">Technologies</h2>
          <div className="flex gap-6 flex-wrap">
            <Technologies technologies={technologies} />
          </div>

          <hr className="my-10"></hr>
          <a
            href="https://github.com/eddiemg10/Strathmore-Disciplinary-System"
            target="_blank"
            className=" text-cool-300 hover:cursor-pointer flex gap-5"
          >
            <BsGithub size={30} />
            <p className="flex items-center">
              <span>Github repository</span> <FiExternalLink className="ml-2" />{" "}
            </p>
          </a>
        </div>
        <div className="mt-20 w-full flex flex-col  items-center justify-center">
          <div className="md:w-[90%] w-full">
            <FullCarousel images={images} />
          </div>
        </div>

        <div className="font-thin text-cool-400 lg:text-xl md:text-lg text-base lg:px-20 md:px-10 px-5 mt-20">
          <p className="my-5">
            This was a project aimed at increasing parental involvement in
            Strathmore School through the digitization of the current manual
            disciplinary record keeping system. The system was able to eliminate
            redundant activities in the manual process, making it faster and
            more efficient to track student disciplinary records. In addition to
            this, it notifies parents via email when their child receives
            detention/any discipline related warning.
          </p>

          <p className="my-5">
            {" "}
            The system is built on the Laravel 9 PHP framework. Tailwind CSS was
            used as the frontend framework to make the interfaces responsive
            across all screen sizes.
          </p>

          <p className="my-5">
            {" "}
            The biggest challenge with the manual system was that detention
            lists had to be created by cross checking multiple documents and
            manually typing out disciplinary entries while regularly tracking
            the disciplinary record of every student. The web system made this a
            much more efficient process by automatically generating printable
            detention lists and automatically flagging students whose discipline
            record require further action.
          </p>
        </div>

        <div className="mt-20 w-full">
          <h1 className="font-semibold text-4xl text-cool-400 text-center">
            System Demo
          </h1>

          <div className="w-full  mt-20">
            <Demo demos={demos} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Strathmore;
